var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWashington(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "288px",
    height: "288px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M253.08,104.031c-26.029-3.718-154.303-39.66-154.303-39.66l5.731,15.338c0,0-3.02,4.646-3.717,7.202 c-0.698,2.556-8.134,9.76-8.134,9.76s-22.773-5.811-30.444-8.132c-7.666-2.325-20.68-18.592-20.68-18.592L35.26,89.701 c0.099,0.168,0.196,0.333,0.288,0.498c4.318,7.536,3.419,10.705,2.965,23.671c-0.465,13.246-3.253,47.87-3.253,47.87l9.603,3.602 l3.41,1.279l1.625,4.88l9.994,1.627l1.86,22.773l11.153,7.436h11.387l2.789-2.557l18.706,8.714l12.316,0.349l2.906-1.046 l4.879,3.951l9.18-0.231l8.482-4.3l1.742,3.719l30.637-0.232l30.047,6.899l22.141,5.084l1.105,0.254 C226.121,208.447,253.08,104.031,253.08,104.031z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWashington);
export default __webpack_public_path__ + "static/media/washington.9d29703bba9699aa8a3409da8bc1bd6b.svg";
export { ForwardRef as ReactComponent };